// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import InvoiceHistoryState from "@store/Framework/Store/Store/Pages/InvoiceHistory/InvoiceHistoryState";
import { Draft } from "immer";

const initialState: InvoiceHistoryState = {
    selectedInvoices: [],
};

const actions = {
    "Store/Pages/InvoiceHistory/AddInvoiceToSelection": (
        draft: Draft<InvoiceHistoryState>,
        action: { invoiceId: string },
    ) => {
        if (!draft.selectedInvoices.includes(action.invoiceId)) {
            draft.selectedInvoices.push(action.invoiceId);
        }
    },
    "Store/Pages/InvoiceHistory/RemoveInvoiceFromSelection": (
        draft: Draft<InvoiceHistoryState>,
        action: { invoiceId: string },
    ) => {
        draft.selectedInvoices = draft.selectedInvoices.filter(id => id !== action.invoiceId);
    },
    "Store/Pages/InvoiceHistory/ClearSelectedInvoices": (draft: Draft<InvoiceHistoryState>) => {
        draft.selectedInvoices = [];
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type InvoiceHistoryActions = Parameters<typeof reducer>[1];
export default reducer;
